import { Buffer } from 'buffer';
import process from 'process/browser';

declare global {
  interface Window {
    Buffer?: typeof Buffer;
    process?: typeof process;
    global?: typeof globalThis;
  }

  // eslint-disable-next-line no-var
  var Buffer: typeof Buffer | undefined;
  // eslint-disable-next-line no-var
  var process: typeof process | undefined;
  // eslint-disable-next-line no-var
  var global: typeof globalThis | undefined;
}

if (typeof globalThis !== 'undefined') {
  globalThis.Buffer = globalThis.Buffer || Buffer;
  globalThis.process = globalThis.process || process;
  globalThis.global = globalThis.global || globalThis;
}

if (typeof window !== 'undefined') {
  window.Buffer = window.Buffer || Buffer;
  window.process = window.process || process;
  window.global = window.global || globalThis;
}